export enum SocialMedia {
  FB = 'https://www.facebook.com/ErasmusPlusMorocco',
  INSTA = 'https://www.instagram.com/ErasmusPlusMorocco/',
  TWITTER = 'https://twitter.com/erasmusplusma',
  YOUTUBE = 'https://www.youtube.com/channel/UCEfg-WhllOkLNm2o1pUlxBw',
}
